module.exports = __webpack_public_path__ + "img/Account-Transaction-Bundled-Grey.1cde9df3.svg";